import useRequest, { RequestTypes } from './useRequest'
import { currencyFormat } from '../helpers'
import { useEffect } from 'react'

interface IGetTariffForCreateCertificate {
    id: number
    volume?: number
    currentCreatedAt?: string
    isUnderLimit?: boolean
    tsPayed?: number
    dependency?: boolean
    showError?: boolean
}

export const useGetTariffRateForCreateCertificate = ({
    dependency = true,
    id,
    volume,
    currentCreatedAt,
    isUnderLimit,
    tsPayed,
    showError = true,
}: IGetTariffForCreateCertificate) => {

    const { fetch, result, isLoading } = useRequest({
        link: '/api/billing/v1/tariff-rate-for-create-certificate',
        method: RequestTypes.post,
    })

    useEffect(() => {
        if (dependency) {
            fetch({
                showError,
                body: { 
                    operation_type_id: id, 
                    volume: volume, 
                    ts_created: currentCreatedAt, 
                    is_under_limit: isUnderLimit, 
                    ts_payed_to: tsPayed 
                },
            })
        }
    }, [dependency])

    return {
        isLoading,
        loadingTariffs: dependency && (isLoading || !result),
        balance: `${currencyFormat(result?.available_balance)} ₽`,
        rate: `${currencyFormat(result?.rate)} ₽`,
        rateNumber: Number(result?.rate),
        payTo: result?.ts_pay_account_to,
        balanceNumber: Number(result?.available_balance),
    }
}
